import { useQuery } from '@tanstack/react-query';
import React from 'react';
import IconLineUp from '../../../icons/icon-line-up';
import { formatCurrency } from '../../../utils/format-data';
import CardTotal from '../../components/card-total';
import { fetchReportSummaryStats } from '../../../cores/api/api-dashboard';
export default function SectionSaleDayWeekMonth() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const _useQuery = useQuery({
        queryKey: ['fetchReportSummaryStats'],
        queryFn: () => fetchReportSummaryStats(),
        suspense: true
    }), data = _useQuery.data;
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-4 lg:col-span-1"
    }, /*#__PURE__*/ React.createElement(CardTotal, {
        title: "\u4ECA\u6708",
        total: formatCurrency({
            value: (_a = data === null || data === void 0 ? void 0 : data.data.this_month.total_sales) !== null && _a !== void 0 ? _a : 0
        }),
        growthTitle: `前月と${((_b = data === null || data === void 0 ? void 0 : data.data.this_month.change_percent) !== null && _b !== void 0 ? _b : 0) >= 0 ? 'アップ' : '下がる'}`,
        icon: /*#__PURE__*/ React.createElement(IconLineUp, null),
        isDown: ((_c = data === null || data === void 0 ? void 0 : data.data.this_month.change_percent) !== null && _c !== void 0 ? _c : 0) < 0,
        change_percent: (_d = data === null || data === void 0 ? void 0 : data.data.this_month.change_percent) !== null && _d !== void 0 ? _d : 0
    }), /*#__PURE__*/ React.createElement(CardTotal, {
        title: "\u4ECA\u9031",
        total: formatCurrency({
            value: (_e = data === null || data === void 0 ? void 0 : data.data.this_week.total_sales) !== null && _e !== void 0 ? _e : 0
        }),
        growthTitle: `先週と${((_f = data === null || data === void 0 ? void 0 : data.data.this_week.change_percent) !== null && _f !== void 0 ? _f : 0) >= 0 ? 'アップ' : '下がる'}`,
        icon: /*#__PURE__*/ React.createElement(IconLineUp, null),
        isDown: ((_g = data === null || data === void 0 ? void 0 : data.data.this_week.change_percent) !== null && _g !== void 0 ? _g : 0) < 0,
        change_percent: (_h = data === null || data === void 0 ? void 0 : data.data.this_week.change_percent) !== null && _h !== void 0 ? _h : 0
    }), /*#__PURE__*/ React.createElement(CardTotal, {
        title: "\u4ECA\u65E5",
        total: formatCurrency({
            value: (_j = data === null || data === void 0 ? void 0 : data.data.today.total_sales) !== null && _j !== void 0 ? _j : 0
        }),
        growthTitle: `昨日と${((_k = data === null || data === void 0 ? void 0 : data.data.today.change_percent) !== null && _k !== void 0 ? _k : 0) >= 0 ? 'アップ' : '下がる'}`,
        icon: /*#__PURE__*/ React.createElement(IconLineUp, null),
        isDown: ((_l = data === null || data === void 0 ? void 0 : data.data.today.change_percent) !== null && _l !== void 0 ? _l : 0) < 0,
        change_percent: (_m = data === null || data === void 0 ? void 0 : data.data.today.change_percent) !== null && _m !== void 0 ? _m : 0
    }));
}
